import type { TableColumnsType } from 'ant-design-vue'

export const DICTIONARY_COLUMNS: TableColumnsType = [
  {
    title: '字典Key',
    dataIndex: 'key',
    width: '30%',
    ellipsis: true,
  },
  {
    title: '字典名称',
    dataIndex: 'name',
    width: '30%',
    ellipsis: true,
  },
  {
    title: '操作',
    dataIndex: 'operation',
    width: '40%',
    ellipsis: true,
  }
]

export interface DictionaryForm {
  name: string
  key: string
}

export const ITEM_COLUMNS: TableColumnsType = [
  {
    title: '条目Key',
    dataIndex: 'key',
    width: '25%',
    ellipsis: true,
  },
  {
    title: '条目名称',
    dataIndex: 'name',
    width: '25%',
    ellipsis: true,
  },
  {
    title: '条目序号',
    dataIndex: 'index',
    width: '25%',
    ellipsis: true,
  },
  {
    title: '操作',
    dataIndex: 'operation',
    width: '25%',
    ellipsis: true,
  }
]